/**
 * Created by katarinababic on 25.11.24.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useTrans } from '../../Store/System/LocalizationStore';
import styled from '@emotion/styled';
import { Col, Container, Row } from 'reactstrap';
import { Translation } from '../../Components/Translation';
import { Button } from '../../Components/Button';
import { Link } from 'react-router-dom';

const ContentContainer = styled.div`
  padding: 2rem 0;

  @media (min-width: 768px) {
    padding: 32px 0;
  }
`;

const ImageCol = styled(Col)`
  text-align: center;

  @media (min-width: 768px) {
    padding-left: 64px;
  }
`;

const TextCol = styled(Col)`
  @media (min-width: 768px) {
    padding-right: 64px;
  }
`;

const Image = styled.img`
  height: 300px;

  @media (min-width: 768px) {
    height: 400px;
  }
`;

const Title = styled.h3`
  font-size: 2rem;
  font-weight: bold;
`;

const AccentText = styled.span`
  color: #00dda2;
`;

const Text = styled.p`
  font-size: 1.2rem;
`;

export type MentalHealthLibrarySectionProps = {};

export const MentalHealthLibrarySection: React.FC<MentalHealthLibrarySectionProps> = observer((props) => {
  const { t } = useTrans();

  return (
    <ContentContainer>
      <Container>
        <Row>
          <ImageCol>
            <Image src={require('../../Assets/Images/mental_health_library_section.png')} />
          </ImageCol>
          <TextCol>
            <Title>
              Find <AccentText>all mental health content</AccentText> in the library
            </Title>
            <Text>
              <Translation
                i18nKey="mentalHealthScreen.librarySection.description"
                defaultValue={`Looking to boost your mental well-being? We've got you covered! Explore our collection of meditations, breathing exercises, and webinars available anytime, anywhere to support your journey to a healthier mind!`}
              />
            </Text>
            <Button tag={Link} to="library" shadowed={true}>
              {t('moveScreen.onDemandSection.goToLibraryButton', { defaultValue: 'GO TO LIBRARY' })}
            </Button>
          </TextCol>
        </Row>
      </Container>
    </ContentContainer>
  );
});
